/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { OrderByPropertyDto } from '../models/OrderByPropertyDto';
import type { TeamBaseV1Dto } from '../models/TeamBaseV1Dto';
import type { TeamCreateV1Dto } from '../models/TeamCreateV1Dto';
import type { TeamFilterInnerV2Dto } from '../models/TeamFilterInnerV2Dto';
import type { TeamPaginatedV1Dto } from '../models/TeamPaginatedV1Dto';
import type { TeamUpdateV1Dto } from '../models/TeamUpdateV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TeamsService {
  /**
   * @param requestBody Create team payload
   * @returns TeamCreateV1Dto create entity
   * @throws ApiError
   */
  public static teamControllerV1CreateTeamV1(
    requestBody: TeamCreateV1Dto,
  ): CancelablePromise<TeamCreateV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/teams',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody Delete many teams payload
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static teamControllerV1DeleteManyTeamsV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/teams',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param orderBy Array of TeamBaseV1Dto order by properties
   * @param page Page number (starts at 1). Used for paginated queries. Must be a positive integer.
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @param filter Filter conditions for querying Teams
   * @param searchString A search string to filter TeamBaseV1Dto by given values.
   * @returns TeamPaginatedV1Dto a entity list wrapped with pagination result
   * @throws ApiError
   */
  public static teamControllerV1GetTeamsV1(
    orderBy?: Array<OrderByPropertyDto> | null,
    page?: number,
    limit?: number,
    filter?: TeamFilterInnerV2Dto | null,
    searchString?: string | null,
  ): CancelablePromise<TeamPaginatedV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/teams',
      query: {
        orderBy: orderBy,
        page: page,
        limit: limit,
        filter: filter,
        searchString: searchString,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid The UUID of the team to delete
   * @returns TeamBaseV1Dto the entity
   * @throws ApiError
   */
  public static teamControllerV1DeleteTeamV1(uuid: string): CancelablePromise<TeamBaseV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/teams/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid The UUID of the team to retrieve
   * @returns TeamBaseV1Dto the entity
   * @throws ApiError
   */
  public static teamControllerV1GetTeamV1(uuid: string): CancelablePromise<TeamBaseV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/teams/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid The UUID of the team to update
   * @param requestBody Update team payload
   * @returns TeamBaseV1Dto the update entity
   * @throws ApiError
   */
  public static teamControllerV1UpdateTeamV1(
    uuid: string,
    requestBody: TeamUpdateV1Dto,
  ): CancelablePromise<TeamBaseV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/teams/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
}
